// extracted by mini-css-extract-plugin
export var scrollContainer = "HotspotCardList-module--scrollContainer--2BW5J";
export var noCardsMessage = "HotspotCardList-module--noCardsMessage--1G-Aw";